import { delay } from './delay';
/**
 * Abre una nueva pestania o ventana para navegar a la URL especificada.
 * Ademas loguea dicha accion.
 *
 * @param {string} url a la cual se debe navegar
 * @param {string} [description] a mostrar en el log junto a la URL.
 */
export function newTab(url, description) {
    if (description) {
        console.info("Navegando a '%s' (URL: '%s')", description, url);
    }
    else {
        console.info("Navegando a URL: '%s'", url);
    }
    window.open(url, '_blank');
}
/**
 * Determina si el dispositivo tiene capacidad touch
 *
 * @returns
 */
export function isTouchDevice() {
    return 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
/**
 * Determina si el navegador es IE o no.
 *
 * @returns true si es IE, false en caso contrario
 */
export function isIE() {
    return getIEVersion() > 0;
}
/**
 * Detecta la version de IE
 *
 * @returns la version de IE o falso si el navegador no es IE
 */
export function getIEVersion() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }
    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        const rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }
    const edge = ua.indexOf('Edge/');
    if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }
    // other browser
    return 0;
}
/**
 * Hace foco sobre un componente, esperando opcionalmente los ms que se especifican
 * @param element a enfocar
 * @param delayMs delay opcional.
 */
export function focus(element, delayMs) {
    if (delayMs !== undefined) {
        delay(delayMs).then(() => element.focus());
    }
    else {
        element.focus();
    }
}
const FOCUSABLE_SELECTOR = 'a[href], area[href], ' +
    'input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), ' +
    'iframe, object, embed, *[tabindex]:not([tabindex="-1"]), *[contenteditable]';
export function focusOnNext(opts = {}) {
    const nextElem = findNextFocusable(opts.from || document.activeElement, opts.offset || 1);
    if (opts.cb)
        return opts.cb(nextElem);
    focus(nextElem, opts.delay || 0);
}
export function findNextFocusable(from, offset) {
    const nodes = Array.from(document.querySelectorAll(FOCUSABLE_SELECTOR)).filter(n => !n.getAttribute('tabindex') || parseInt(n.getAttribute('tabindex')) >= 0);
    // Logica radio button
    // if ($from[0].tagName === "INPUT" && $from[0].type === "radio" && $from[0].name !== "") {
    //     var name = internal.escapeSelectorName($from[0].name);
    //     $focusable = $focusable
    //         .not("input[type=radio][name=" + name + "]")
    //         .add($from);
    // }
    const currentIndex = nodes.indexOf(from);
    let nextIndex = (currentIndex + offset) % nodes.length;
    if (nextIndex <= -1) {
        nextIndex = nodes.length + nextIndex;
    }
    return nodes[nextIndex];
}
//# sourceMappingURL=browser.js.map